import React from 'react';
import { bool, object, string } from 'prop-types';
import LimitedEdition from './LimitedEdition';
import Checkout from './Checkout';

const CtaBtn = ({ inProgress, price }, { general }) => {
    const { isLimitedEdition } = general;

    return (
        <>
            {isLimitedEdition ? <LimitedEdition/> : <Checkout inProgress={inProgress} price={price}/>}
        </>
    );
};

CtaBtn.propTypes = {
    inProgress: bool,
    price: string
};

CtaBtn.contextTypes = {
    general: object
};

export default CtaBtn;
